export default "__VITE_ASSET__DTs61RTb__"